import { requestBuilder } from '../../../http/RequestBuilder';
import type { Transaction } from '../../types/Transactions';

export interface AchTransactionSimulationRequest {
    account_number: string;
    amount: number;
    dc_sign: AchTransactionSimulationRequestDcSignEnum;
    effective_date: string;
}

export const AchTransactionSimulationRequestDcSignEnum = {
    Credit: 'credit',
    Debit: 'debit',
} as const;

export type AchTransactionSimulationRequestDcSignEnum =
    (typeof AchTransactionSimulationRequestDcSignEnum)[keyof typeof AchTransactionSimulationRequestDcSignEnum];

export interface IncomingAchSimulationResponse {
    success: boolean;
    normalizedTransaction: Transaction | null;
}

const useCreateIncomingAchSimulation = requestBuilder.mutation<
    IncomingAchSimulationResponse,
    AchTransactionSimulationRequest
>({
    endpoint: '/api/transaction-simulations/incoming-ach',
    method: 'POST',
});

export default useCreateIncomingAchSimulation;
